"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSetStatusToJSON = exports.AdSetStatusFromJSONTyped = exports.AdSetStatusFromJSON = exports.AdSetStatus = void 0;
/**
 * Status of the ad set.
 * @export
 */
exports.AdSetStatus = {
    Active: 'ACTIVE',
    Approved: 'APPROVED',
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    PendingAdvertiserApproval: 'PENDING_ADVERTISER_APPROVAL',
    PendingApproval: 'PENDING_APPROVAL',
    Ready: 'READY',
    Rejected: 'REJECTED'
};
function AdSetStatusFromJSON(json) {
    return AdSetStatusFromJSONTyped(json, false);
}
exports.AdSetStatusFromJSON = AdSetStatusFromJSON;
function AdSetStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AdSetStatusFromJSONTyped = AdSetStatusFromJSONTyped;
function AdSetStatusToJSON(value) {
    return value;
}
exports.AdSetStatusToJSON = AdSetStatusToJSON;
